import { BaseContainerModel } from '../../base-container.model';
import { bl_crm_membership_config_RowClass } from '../../../dbschema';

export class MembershipConfigContainerModel extends BaseContainerModel {
  bl_crm_membership_config:bl_crm_membership_config_RowClass = new bl_crm_membership_config_RowClass();
}
